import { render, staticRenderFns } from "./RelatorioGestaoPcaResumoGeralReceita.vue?vue&type=template&id=2bcda864"
import script from "./RelatorioGestaoPcaResumoGeralReceita.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoPcaResumoGeralReceita.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports